import { h } from 'preact';

const MaintenanceMode = () => (
    <div className="et-h-screen et-flex et-justify-center et-flex-col">
        <div class="spinner-box">
            <div class="psoload">
                <div class="straight"></div>
                <div class="curve"></div>
                <div class="center"></div>
                <div class="inner"></div>
            </div>
        </div>

        <div className="et-py-4">
            <div className="et-container et-px-4 et-mx-auto">
                <div className="et-text-center">
                    <div className="et-flex et-justify-center et-mb-10">
                        <img src="/img/neo.svg" alt="Neo Logo" className="et-w-24 lg:et-w-32"/>
                    </div>

                    <h1 className="lg:et-text-4xl lg:et-text-3xl et-text-gray-700 et-font-bold et-mb-4">
                        We'll Be Right Back
                    </h1>

                    <p>We're performing scheduled for maintenance.</p>
                    <p>we'll be back online</p>
                </div>
            </div>
        </div>
    </div>
)

export default MaintenanceMode;